// extracted by mini-css-extract-plugin
export default {"SRFButton":"SRFButton_SRFButton__cQejy"};